import { useEffect, useRef, useState } from 'react';
import { useGT } from 'gt-react';
import { useToast } from 'src/context/ToastContext';
import { useFileDrop } from '@/hooks/useFileDrop';
import { resolvePricelistDrop } from './resolvePricelistDrop';

export function usePricelistCaseAttachDrop({
  disabled = false,
}: {
  disabled?: boolean;
} = {}) {
  const gt = useGT();
  const { showToast } = useToast();
  const [uploadOpen, setUploadOpen] = useState(false);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const attachAllowedRef = useRef(!disabled);

  useEffect(() => {
    attachAllowedRef.current = !disabled;
  }, [disabled]);

  function onDropFiles(files: File[]) {
    void resolvePricelistDrop(files, gt, {
      acceptPrintablePlainText: true,
    }).then(({ files: accepted, rejections }) => {
      if (!attachAllowedRef.current) return;
      for (const rejection of rejections) {
        showToast({
          title: rejection.title,
          message: rejection.message,
          color: 'error',
        });
      }
      if (accepted.length === 0) return;
      setPendingFiles(accepted);
      setUploadOpen(true);
    });
  }

  const { isDragActive, dropTargetProps } = useFileDrop({
    onDropFiles,
    disabled,
  });

  function onUploadOpenChange(open: boolean) {
    setUploadOpen(open);
    if (!open) setPendingFiles([]);
  }

  function openEmptyUpload() {
    setPendingFiles([]);
    setUploadOpen(true);
  }

  return {
    isDragActive,
    dropTargetProps,
    uploadOpen,
    pendingFiles,
    pendingFile: pendingFiles[0] ?? null,
    onUploadOpenChange,
    openEmptyUpload,
  };
}
